import { relations } from 'drizzle-orm';
import { userRoles } from '../models/userRoles';
import { users } from '../models/users';
import { roles } from '../models/roles';

/**
 * @group UserRole
 * @summary UserRole relations for the database schema
 *
 * @remarks
 * Defines the relationships for the userRoles table, including user and role.
 *
 * @example
 * ```typescript
 * import { userRoleRelations } from '@shared/db';
 *
 * // Query userRole with user and role
 * const userRoleWithDetails = await db.query.userRoles.findFirst({
 *   where: eq(userRoles.id, userRoleId),
 *   with: {
 *     user: true,
 *     role: true
 *   }
 * });
 * ```
 */
export const /**
 * @internal
 */
userRoleRelations = relations(userRoles, ({ one }) => ({
  user: one(users, {
    fields: [userRoles.user_id],
    references: [users.id],
  }),
  role: one(roles, {
    fields: [userRoles.role_id],
    references: [roles.id],
  }),
})); 